module.exports = __webpack_public_path__ + "img/VEGETARIAN_FOOD.c5d61028.webp";